<script setup>
defineProps({
  large: {
    type: Boolean,
    default: false
  }
})
</script>
<template>
  <div
    class="mx-auto px-4 lg:px-5"
    :class="{
      container: !large,
      'max-w-full xl:w-[1312px]': large
    }"
  >
    <slot />
  </div>
</template>
